// extracted by mini-css-extract-plugin
export default {"pageWrapper":"BigBassSlots_pageWrapper__8TMox"};